import React from 'react';

// @ts-expect-error - Automatic, Please fix when editing this file
const withLoadData = (Component, loadData) => (routeProps) => <Component loadData={loadData} {...routeProps} />;

export default withLoadData;
